<fieldset class="phone-field-group" [formGroup]="formGroup()">
  <legend class="phone-field-group__legend">
    {{ 'createShipment.fields.phoneGroupLegend' | translate }}
  </legend>

  <div class="phone-field-group__fields">
    <div class="phone-field-group__composite-block">
      <div
        class="phone-field-group__composite"
        [class.phone-field-group__composite--error]="!!phoneNumberError()"
      >
        <puro-select
          class="phone-field-group__country-code"
          formControlName="phoneCountryCode"
          [options]="countryCodeOptions"
          [fullWidth]="true"
          [label]="'createShipment.fields.phoneCountryCode' | translate"
          labelPosition="top"
        />

        <puro-input
          class="phone-field-group__number"
          [label]="'createShipment.fields.phoneNumber' | translate"
          [placeholder]="'createShipment.fields.phoneNumberPlaceholder' | translate"
          type="tel"
          formControlName="phoneNumber"
          [name]="avsFieldName('phoneNumber')"
          appDisableBrowserAutofill="disabled"
          [required]="phoneRequired()"
          [fullWidth]="true"
          [error]="!!phoneNumberError()"
          [endAdornment]="showPhoneTooltip()"
          (focusout)="onFieldBlur('phoneNumber')"
        >
          @if (showPhoneTooltip()) {
            <span endAdornment class="phone-field-group__tooltip-icon">
              <span class="visually-hidden" [id]="phoneTooltipDescId()">{{
                'createShipment.fields.phoneNumberTooltip' | translate
              }}</span>
              <puro-tooltip
                #phoneTooltip
                [content]="'createShipment.fields.phoneNumberTooltip' | translate"
              >
                <button
                  type="button"
                  class="phone-field-group__tooltip-trigger"
                  [attr.aria-label]="'createShipment.fields.phoneNumberTooltipAria' | translate"
                  [attr.aria-describedby]="phoneTooltipDescId()"
                  (click)="$event.preventDefault(); $event.stopPropagation()"
                  (focus)="phoneTooltip.show()"
                  (blur)="phoneTooltip.hide()"
                >
                  <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
                </button>
              </puro-tooltip>
            </span>
          }
        </puro-input>
      </div>

      @if (phoneNumberError()) {
        <p class="phone-field-group__error" role="alert">
          {{ phoneNumberError() }}
        </p>
      }
    </div>

    <puro-input
      class="phone-field-group__extension"
      [label]="'createShipment.fields.phoneExtension' | translate"
      formControlName="phoneExtension"
      [name]="avsFieldName('phoneExtension')"
      appDisableBrowserAutofill="disabled"
      [fullWidth]="true"
      [error]="!!phoneExtensionError()"
      [errorMessage]="phoneExtensionError() ?? ''"
      (focusout)="onFieldBlur('phoneExtension')"
    />
  </div>
</fieldset>
